import { useMemo } from 'react';

export const useSoc2PasswordValidation = (formData, password, minLength = 12) => {
  const soc2Active = useMemo(() => {
    const {data: {validators = []} = {}} = formData || {};
    return validators.some(validatorName => validatorName === 'Soc2PasswordValidator');
  }, [formData]);

  const [soc2Valid, validationTypes] = useMemo(() => {
    if (soc2Active) {
      if (password) {
        const validations = {
          length: password.length > minLength,
          lower: /[a-z]/.test(password),
          upper: /[A-Z]/.test(password),
          number: /[0-9]/.test(password),
          special: /[^a-zA-Z0-9\s]/.test(password)
        };
        return [
          Object.values(validations).every(validation => validation),
          validations
        ];
      }
      return [
        false,
        {
          length: null,
          lower: null,
          upper: null,
          number: null,
          special: null
        }
      ];
    }
    return [true, {}];
  }, [soc2Active, minLength, password]);
  return {
    soc2Active,
    soc2Valid,
    validationTypes
  };
};
